import { Box, Button, Typography } from '@mui/material';
import { FC } from 'react';
import { AgentDirectoryEntry } from '../../../../interfaces/calls';

interface TransferConfirmationModalProps {
  open: boolean;
  agent: AgentDirectoryEntry | null;
  transferType: 'WARM' | 'BLIND' | null;
  onConfirm: () => void;
  onCancel: () => void;
}

export const TransferConfirmationModal: FC<TransferConfirmationModalProps> = ({
  open,
  agent,
  transferType,
  onConfirm,
  onCancel,
}) => {
  if (!agent || !transferType) {
    return null;
  }

  const isBlindTransfer = transferType === 'BLIND';

  return (
    <Box
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: '8px',
        padding: '24px',
        background: '#fff',
        maxWidth: 300,
        width: '70%',
        boxShadow: 3,
        display: open ? 'block' : 'none',
        zIndex: 10,
      }}>
      <Box sx={{ textAlign: 'center', pb: 1 }}>
        <Typography sx={{ fontWeight: 600, fontSize: '14px' }}>
          Transfer call to {agent.name}?
        </Typography>
      </Box>

      <Box sx={{ textAlign: 'center', pt: 1, pb: 2 }}>
        {isBlindTransfer && (
          <Typography variant='body2' color='text.secondary'>
            You will be disconnected immediately after confirm
          </Typography>
        )}
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
          pb: 2,
        }}>
        <Button
          fullWidth
          onClick={onConfirm}
          variant='contained'
          sx={{
            textTransform: 'none',
            minWidth: '100px',
            bgcolor: '#1A667A',
            '&:hover': {
              bgcolor: '#155563',
            },
          }}>
          Confirm transfer
        </Button>
        <Button
          onClick={onCancel}
          fullWidth
          variant='outlined'
          sx={{
            textTransform: 'none',
            minWidth: '100px',
            borderColor: '#d2d2d2',
            color: '#666',
            '&:hover': {
              borderColor: '#1A667A',
              bgcolor: 'rgba(26, 102, 122, 0.04)',
            },
          }}>
          Cancel
        </Button>
      </Box>
    </Box>
  );
};
